import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OdinAuthenticationComponent } from './odin-authentication/odin-authentication.component';
import { OdinAuthenticationRoutingModule } from './odin-authentication/odin-authentication-routing.module';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { OdinCoreModule } from '@odin/odin-core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { UnauthorisedComponent } from './components/unauthorised/unauthorised.component';
import { MatCardModule } from '@angular/material/card';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {ForgotPasswordComponent} from "./components/forgot-password/forgot-password.component";
import {MfaAuthStepComponent} from "./components/mfa-auth-step/mfa-auth-step.component";
import {MfaConfiguratorComponent} from "./components/mfa-configurator/mfa-configurator.component";
import {UiDefaultsConfiguratorComponent} from "./components/ui-defaults-configurator/ui-defaults-configurator.component";
import {QrCodeComponent} from "ng-qrcode";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    OdinCoreModule,
    MatCardModule,
    FontAwesomeModule,
    MatIconModule,
    MatSlideToggleModule,
    QrCodeComponent,
  ],
  declarations: [
    OdinAuthenticationComponent,
    LoginPageComponent,
    ForgotPasswordComponent,
    MfaAuthStepComponent,
    UnauthorisedComponent,
    AuthCallbackComponent,
    MfaConfiguratorComponent,
    UiDefaultsConfiguratorComponent
  ],
  exports: [
    OdinAuthenticationComponent,
    OdinAuthenticationRoutingModule,
    LoginPageComponent,
    ForgotPasswordComponent,
    MfaAuthStepComponent,
    UnauthorisedComponent,
    AuthCallbackComponent,
    MfaConfiguratorComponent,
    UiDefaultsConfiguratorComponent
  ],
  providers: [],
})
export class OdinAuthenticationModule {}
